import * as Sentry from "@sentry/vue";

import { getGroupByDefinitionList } from "~/common/groupBy";
import { getPropertyWithConfigList } from "~/common/properties";
import { UnknownFieldIcon } from "~/icons";
import { PropertyKind } from "~/shared/enums";
import type { ChartPropertyOption, GroupByGroup } from "~/shared/types";

export const getAllGroupByDefinitionList = () => getGroupByDefinitionList(getPropertyWithConfigList());

export const getOptionsForProperty = (propertyDuid: string): GroupByGroup[] =>
  getAllGroupByDefinitionList().find((e) => e.property.duid === propertyDuid)?.groups ?? [];

export const TIME_TRACKING_KINDS = new Set([PropertyKind.DEFAULT_TIME_TRACKING, PropertyKind.TIME_TRACKING]);

export const getFullOptionsForProperty = (
  options: ChartPropertyOption[] | undefined,
  propertyDuid: string | null
): GroupByGroup[] => {
  if (!options || !propertyDuid) {
    return [];
  }

  const allOptionsMap = new Map(getOptionsForProperty(propertyDuid).map((e) => [e.id, e]));
  const fullOptions = options.map((e) => allOptionsMap.get(e.id) ?? { ...e, colorHex: "#111", icon: UnknownFieldIcon });
  const missingBackendOptions = options.filter((option) => !allOptionsMap.has(option.id));
  if (missingBackendOptions.length > 0) {
    Sentry.captureMessage("Chart: mismatch between local and backend options", {
      extra: {
        propertyDuid,
        localOptions: options,
        backendOptions: fullOptions,
        missingBackendOptions: missingBackendOptions.map((opt) => opt.id),
      },
    });
  }
  return fullOptions;
};
